import React from 'react'

export const NotFound = () => {
  return (
    <div className='text-6xl h-[630px] flex justify-center items-center flex-col bg-[#111111]'>
        <h1>404</h1>
        <p>Page not found</p>
    </div>
  )
}